import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import {TransferState,makeStateKey} from '@angular/platform-browser';
import { Observable } from 'rxjs/internal/Observable';
  
const sliderData = makeStateKey('sliderData');


@Injectable({
  providedIn: 'root'
})
export class HomeService {
  someDataObservable: Observable<any>;

  constructor(private http: HttpClient,    private state: TransferState    ) { }

  getSlides ():any{

    if (this.someDataObservable) {
      return this.someDataObservable;
    } else {
      this.someDataObservable  = this.http.get<any>(`${environment.URLSite}sliders.json`)
    return this.someDataObservable
    }
  }

  getWorks () :any{

      return  this.http.get<any>(`${environment.URLSite}ourworks/worklist.json`)
    
  } 
  
  getMarketWorks () {
    return this.http.get(`${environment.URLSite}ourworks/marketappslist.json`);
  }    
}
